<template>
  <header class="header">
    <div class="wrapper">
      <div class="header__container">
        <a
          :href="homeUrl"
          target="_blank"
          :class="[
            'header__logo',
          ]"
        >
          <Logo class="header__logo-image" isWhite />
        </a>
        <h1 class="header__title">{{ $t('List of arrived HAP vessels') }}</h1>
      </div>
    </div>
  </header>
</template>

<script>
import Logo from '@/Theme/Components/02-atoms/Logo/Logo.vue';
import env from '@/env';

export default {
  name: 'Header',
  components: {
    Logo,
  },
  data() {
    return {
      homeUrl: env.homeUrl,
    };
  },
};
</script>

<style scoped lang="scss">
.header {
  background-color: $color-secondary;
  height: 5rem;
  padding: 1.1rem;
  width: 100%;
  @include media-breakpoint-up(md) {
    left: 0;
    padding: 1rem;
    position: absolute;
    top: 0;
    z-index: 3;
  }
  &__container {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  &__menu-toggle-button {
    color: $white;
    font-size: 2.5rem;
    line-height: 1;
    position: relative;
    top: .2rem;
  }
  &__logo {
    margin: 0 auto;
    @include media-breakpoint-up(md) {
      margin-left: 1.4rem;
      margin-right: 0;
    }
    &-image {
      height: 2rem;
      @include media-breakpoint-up(md) {
        width: 19rem;
      }
    }
  }
  &__title {
    display: none;
    @include media-breakpoint-up(md) {
      display: block;
      color: $white;
      font-size: 2rem;
      margin: 0 auto;
      padding: 0 2rem;
    }
  }
}
</style>
